<template>
	<!-- Vue Material Input -->
	<!-- https://vuematerial.io/components/input -->

	<md-field :class="{ 'md-invalid': error }">
		<md-icon v-if="icon" :class="icon"/>
		<label>{{ label }}</label>
		<md-textarea
			:autofocus="autofocus"
			:disabled="disabled"
			:md-autogrow="autogrow"
			:readonly="readonly"
			:required="required"
			:value="value"
			@input="$emit('input', $event)"
			@change="$emit('change', $event)"
			@keyup.enter="$emit('enter', $event)"
			@blur.native="$emit('blur', $event)"
		/>
		<md-icon v-if="inlineIcon" :class="inlineIcon"/>
		<transition name="fade">
			<span v-if="flashHintText" class="md-helper-text">{{ flashHintText }}</span>
		</transition>
		<span v-if="!flashHintText && hint" class="md-helper-text">{{ hint }}</span>
		<span v-if="error" class="md-error">{{ error }}</span>
	</md-field>
</template>

<script>
export default {
	name: "TextArea",
	props: {
		autogrow: {
			type: Boolean,
			default: false,
			required: false
		},
		autofocus: {
			type: Boolean,
			default: false,
			required: false
		},
		disabled: {
			type: Boolean,
			default: false,
			required: false
		},
		error: {
			type: String,
			default: "",
			required: false
		},
		inlineIcon: {
			type: String,
			default: "",
			required: false
		},
		label: {
			type: String,
			required: true
		},
		hint: {
			type: String,
			default: "",
			required: false
		},
		icon: {
			type: String,
			default: "",
			required: false
		},
		readonly: {
			type: Boolean,
			default: false,
			required: false
		},
		required: {
			type: Boolean,
			default: false,
			required: false
		},
		value: {
			type: String,
			default: "",
			required: false
		}
	},
	data () {
		return {
			flashHintText: ""
		};
	},
	beforeDestroy() {
		clearTimeout(this.flashHintTimeout);
	},
	methods: {
		flashHint(hintText) {
			if (hintText.length === 0)
				return;

			this.flashHintText = hintText;

			clearTimeout(this.flashHintTimeout);

			this.flashHintTimeout = setTimeout(() => {
				this.flashHintText = "";
			}, 2000);
		}
	}
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>

<style lang="scss">
.ui-icon--inline {
	.md-button {
		margin-right: 0;
	}
}
</style>
